'use client'

import { Auth } from 'aws-amplify'
import { initAmplify } from '@/helpers/amplifyConfig'
import React, { PropsWithChildren, useEffect } from 'react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

const CanteenAuth: React.FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    initAmplify()
    const checkLogin = async () => {
      try {
        await Auth.currentAuthenticatedUser()
      } catch (_) {
        const params = searchParams?.toString() ?? ''
        router.replace(
          `/authentication/login?destination=${pathname}${params.length ? `?${params}` : ''}`,
        )
      }
    }
    checkLogin()
  }, [router, pathname, searchParams])

  return <>{children}</>
}

export default CanteenAuth
